import GroceryCard from '../generic/GroceryCard';
import CyoElement from './CyoElement';
import { PAGES } from '../constants/order_details';

const GroceryList = ({
  loading,
  freeItem,
  freeItemEffect,
  groceryItems,
  togglePdpModal,
  showRatings,
  page,
  promoHasNonCYOFreeItem,
  customerCyo,
}) => {
  if (loading) {
    return null;
  }
  const isUpcoming = page === PAGES.upcoming;

  return (
    <div id={'grocery-list-component'}>
      {isUpcoming && customerCyo ? (
        <CyoElement customerCyo={customerCyo} togglePdpModal={togglePdpModal} />
      ) : null}
      {groceryItems.map((productCategoryObj) => {
        return productCategoryObj.products.length ? (
          <div
            key={productCategoryObj.id}
            className={'sectionContainer hr-mb-8'}
          >
            <div className={'groceryItemHeader hr-subtitle-md-bold hr-mb-16'}>
              {productCategoryObj.name}
            </div>
            {productCategoryObj.products.map((product, idx) => {
              return (
                <GroceryCard
                  sku={product}
                  qty={product.quantity}
                  key={idx}
                  showRatings={showRatings}
                  onClick={() => togglePdpModal(product)}
                />
              );
            })}
          </div>
        ) : null;
      })}
      {
        // show free items component only if there is a non for life free item
        freeItem && freeItemEffect && promoHasNonCYOFreeItem ? (
          <div className={'cookieDoughPromo'}>
            <img
              className="cookie-reminder-img"
              src={'/public/img/dashboard/free_item.svg'}
              alt="Decorative cookie"
            />
            <div className={'hr-subtitle-md-bold'}>+ {freeItemEffect}</div>
          </div>
        ) : null
      }
    </div>
  );
};

export default GroceryList;
